export { default } from './StatsGraphBackground'
